window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace rte
 */

slate.rte = {

  wrapTable: function() {
    $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
  },

  iframeReset: function() {
    var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
    var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

    $iframeVideo.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="rte__video-wrapper"></div>');
    });

    $iframeReset.each(function() {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  },

  searchLinks: function(parent, children) {
    // Initialize
    var results = [];
    // Loop through youtube regular expressions array
    $.each($(parent).find(children), function(index, value) {
      // Match elements containg youtube urls
      var match = $(this).text().match(/(http:|https:)?\/\/(www\.)?(youtube.com|youtu.be)\/(watch)?(\?v=)?(\S+)?/);
      if(match != null) {
        // console.log($(this));
        // Add matched URL to results
        var id = match[0].split('?');
        slate.rte.wrapLink($(this), id[1]);
        // results.push(match);
      }
    });
    // Return our links
    return results;
  },

  wrapLink: function(el, videoId) {
    $(el).replaceWith('<iframe width="560" height="315" src="//www.youtube.com/embed/' + videoId + '" frameborder="0" allowfullscreen></iframe>');
    // $(el).replaceWith('<iframe width="420" height="315" src="'+link+'"></iframe>');
  },
  
  findYoutubeLinks: function() {
    // Get results example usage
    // console.log('find youtube links');
    var links = slate.rte.searchLinks('.rte', 'div, li, p');
    
    $.each(links, function(index, value) {
      // console.log(value[0]);
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/**
 * Quantity Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the quantity inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the quantity
 * price or image changes.
 *
 * @namespace quantity
 */

slate.Quantity = (function() {

  /**
   * Quantity constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Quantity(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.quantitySelector = options.quantitySelector;
    this.currentQuantity = this._getCurrentQuantity();
    this.quantityProperty = options.quantityProperty;
    this.type = this._getCurrentType();
    // // this.originalSelectorId = options.originalSelectorId;
    // this.enableHistoryState = options.enableHistoryState;
    // this.currentQuantity = this._getQuantityFromOption();

    if( this.type === 'number' ) {
      $(this.quantitySelector, this.$container).on('mouseup keyup', this._onSelectChange.bind(this));
    } else {
      $(this.quantitySelector, this.$container).on('change', this._onSelectChange.bind(this));
    }
  }

  Quantity.prototype = $.extend({}, Quantity.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentQuantity: function() {
      // var currentOptions = $.map($(this.quantitySelector, this.$container), function(element) {
        // var $element = $(element);
        var $element = $(this.quantitySelector, this.$container);
        // console.log($element);
        // var type = $element.attr('type');
        // var currentOption = {};
        var currentOption = $element.val();

        // if (type === 'radio' || type === 'checkbox') {
        //   if ($element[0].checked) {
        //     currentOption.value = $element.val();
        //     currentOption.index = $element.data('index');

        //     return currentOption;
        //   } else {
        //     return false;
        //   }
        // } else {
          // currentOption.value = $element.val();
          // currentOption.index = $element.data('index');

          // return currentOption;
        // }
      // });

      // remove any unchecked input values if using radio buttons or checkboxes
      // currentOptions = slate.utils.compact(currentOptions);
      // return currentOptions;

      return currentOption;
    },

    /**
     * Get type of element
     *
     * @return {string} type of element
     */
    _getCurrentType: function() {
        var $element = $(this.quantitySelector, this.$container);
        var type = $element.attr('type');
        var currentType = 'select';

        if (type === 'number') {
          currentType = 'number';
        }
        
        return currentType;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    // _getQuantityFromOption: function() {
    //   var selectedValues = this._getCurrentQuantity();
    //   var variants = this.product.variants;
    //   var found = false;

      // variants.forEach(function(variant) {
      //   var satisfied = true;

      //   selectedValues.forEach(function(option) {
      //     if (satisfied) {
      //       satisfied = (option.value === variant[option.index]);
      //     }
      //   });

      //   if (satisfied) {
      //     found = variant;
      //   }
      // });

    //   return found || null;
    // },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      // var quantity = this._getQuantityFromOption();
      var quantity = this._getCurrentQuantity();

      this.$container.trigger({
        type: 'quantityChange',
        quantity: quantity.value
      });

      if (!quantity) {
        return;
      }

      $(this.quantityProperty, this.$container).val( quantity + ' ' + $('[data-product-unit-property]').val() );
      // this._updatePrice(quantity);
      this.currentQuantity = quantity;

      // if (this.enableHistoryState) {
      //   this._updateHistoryState(quantity);
      // }
    }

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    // _updatePrice: function(variant) {
    //   if (variant.price === this.currentQuantity.price && variant.compare_at_price === this.currentQuantity.compare_at_price) {
    //     return;
    //   }

    //   this.$container.trigger({
    //     type: 'variantPriceChange',
    //     variant: variant
    //   });
    // }

  });

  return Quantity;
})();



/*================ Modules ================*/
/*============================================================================
  Drawer modules
==============================================================================*/
theme.Drawers = (function() {
    function Drawer(id, position, options) {
      var defaults = {
        close: '.js-drawer-close',
        open: '.js-drawer-open-' + position,
        openClass: 'js-drawer-open',
        dirOpenClass: 'js-drawer-open-' + position
      };
  
      this.nodes = {
        $parent: $('html').add('body'),
        $page: $('#PageContainer')
      };
  
      this.config = $.extend(defaults, options);
      this.position = position;
  
      this.$drawer = $('#' + id);
  
      if (!this.$drawer.length) {
        return false;
      }
  
      this.drawerIsOpen = false;
      this.init();
    }
  
    Drawer.prototype.init = function() {
      $(this.config.open).on('click', $.proxy(this.open, this));
      this.$drawer.on('click', this.config.close, $.proxy(this.close, this));
    };
  
    Drawer.prototype.open = function(evt) {
      // Keep track if drawer was opened from a click, or called by another function
      var externalCall = false;
  
      // Prevent following href if link is clicked
      if (evt) {
        evt.preventDefault();
      } else {
        externalCall = true;
      }
  
      // Without this, the drawer opens, the click event bubbles up to nodes.$page
      // which closes the drawer.
      if (evt && evt.stopPropagation) {
        evt.stopPropagation();
        // save the source of the click, we'll focus to this on close
        this.$activeSource = $(evt.currentTarget);
      }
  
      if (this.drawerIsOpen && !externalCall) {
        return this.close();
      }
  
      // Add is-transitioning class to moved elements on open so drawer can have
      // transition for close animation
      this.$drawer.prepareTransition();
  
      this.nodes.$parent.addClass(
        this.config.openClass + ' ' + this.config.dirOpenClass
      );
      this.drawerIsOpen = true;
  
      // Set focus on drawer
      slate.a11y.trapFocus({
        $container: this.$drawer,
        namespace: 'drawer_focus'
      });
  
      // Run function when draw opens if set
      if (
        this.config.onDrawerOpen &&
        typeof this.config.onDrawerOpen === 'function'
      ) {
        if (!externalCall) {
          this.config.onDrawerOpen();
        }
      }
  
      if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
        this.$activeSource.attr('aria-expanded', 'true');
      }
  
      this.bindEvents();
  
      return this;
    };
  
    Drawer.prototype.close = function() {
      if (!this.drawerIsOpen) {
        // don't close a closed drawer
        return;
      }
  
      // deselect any focused form elements
      $(document.activeElement).trigger('blur');
  
      // Ensure closing transition is applied to moved elements, like the nav
      this.$drawer.prepareTransition();
  
      this.nodes.$parent.removeClass(
        this.config.dirOpenClass + ' ' + this.config.openClass
      );
  
      this.drawerIsOpen = false;
  
      // Remove focus on drawer
      slate.a11y.removeTrapFocus({
        $container: this.$drawer,
        namespace: 'drawer_focus'
      });
  
      this.unbindEvents();
    };
  
    Drawer.prototype.bindEvents = function() {
      this.nodes.$parent.on(
        'keyup.drawer',
        $.proxy(function(evt) {
          // close on 'esc' keypress
          if (evt.keyCode === 27) {
            this.close();
            return false;
          } else {
            return true;
          }
        }, this)
      );
  
      // Lock scrolling on mobile
      this.nodes.$page.on('touchmove.drawer', function() {
        return false;
      });
  
      this.nodes.$page.on(
        'click.drawer',
        $.proxy(function() {
          this.close();
          return false;
        }, this)
      );
    };
  
    Drawer.prototype.unbindEvents = function() {
      this.nodes.$page.off('.drawer');
      this.nodes.$parent.off('.drawer');
    };
  
    return Drawer;
  })();
theme.Header = (function() {
    var selectors = {
      body: 'body',
      navigation: '#AccessibleNav',
      siteNavHasDropdown: '.site-nav--has-dropdown',
      siteNavChildLinks: '.site-nav__child-link',
      siteNavActiveDropdown: '.site-nav--active-dropdown',
      siteNavLinkMain: '.site-nav__link--main',
      siteNavChildLink: '.site-nav__link--last'
    };
  
    var config = {
      activeClass: 'site-nav--active-dropdown',
      childLinkClass: 'site-nav__child-link'
    };
  
    var cache = {};
  
    function init() {
      cacheSelectors();
  
      cache.$parents.on('click.siteNav', function(evt) {
        var $el = $(this);
  
        if (!$el.hasClass(config.activeClass)) {
          // force stop the click from happening
          evt.preventDefault();
          evt.stopImmediatePropagation();
          showDropdown($el);
        }
      });
  
      // check when we're leaving a dropdown and close the active dropdown
      $(selectors.siteNavChildLink).on('focusout.siteNav', function() {
        setTimeout(function() {
          if (
            $(document.activeElement).hasClass(config.childLinkClass) ||
            !cache.$activeDropdown.length
          ) {
            return;
          }
  
          hideDropdown(cache.$activeDropdown);
        });
      });
  
      // close dropdowns when on top level nav
      cache.$topLevel.on('focus.siteNav', function() {
        if (cache.$activeDropdown.length) {
          hideDropdown(cache.$activeDropdown);
        }
      });
  
      cache.$subMenuLinks.on('click.siteNav', function(evt) {
        // Prevent click on body from firing instead of link
        evt.stopImmediatePropagation();
      });
    }
  
    function cacheSelectors() {
      cache = {
        $nav: $(selectors.navigation),
        $topLevel: $(selectors.siteNavLinkMain),
        $parents: $(selectors.navigation).find(selectors.siteNavHasDropdown),
        $subMenuLinks: $(selectors.siteNavChildLinks),
        $activeDropdown: $(selectors.siteNavActiveDropdown)
      };
    }
  
    function showDropdown($el) {
      $el.addClass(config.activeClass);
  
      // close open dropdowns
      if (cache.$activeDropdown.length) {
        hideDropdown(cache.$activeDropdown);
      }
  
      cache.$activeDropdown = $el;
  
      // set expanded on open dropdown
      $el.find(selectors.siteNavLinkMain).attr('aria-expanded', 'true');
  
      setTimeout(function() {
        $(window).on('keyup.siteNav', function(evt) {
          if (evt.keyCode === 27) {
            hideDropdown($el);
          }
        });
  
        $(selectors.body).on('click.siteNav', function() {
          hideDropdown($el);
        });
      }, 250);
    }
  
    function hideDropdown($el) {
      // remove aria on open dropdown
      $el.find(selectors.siteNavLinkMain).attr('aria-expanded', 'false');
      $el.removeClass(config.activeClass);
  
      // reset active dropdown
      cache.$activeDropdown = $(selectors.siteNavActiveDropdown);
  
      $(selectors.body).off('click.siteNav');
      $(window).off('keyup.siteNav');
    }
  
    function unload() {
      $(window).off('.siteNav');
      cache.$parents.off('.siteNav');
      cache.$subMenuLinks.off('.siteNav');
      cache.$topLevel.off('.siteNav');
      $(selectors.siteNavChildLink).off('.siteNav');
      $(selectors.body).off('.siteNav');
    }
  
    return {
      init: init,
      unload: unload
    };
  })();
theme.MobileNav = (function() {
    var classes = {
      mobileNavOpenIcon: 'mobile-nav--open',
      mobileNavCloseIcon: 'mobile-nav--close',
      navLinkWrapper: 'mobile-nav__item',
      navLink: 'mobile-nav__link',
      subNavLink: 'mobile-nav__sublist-link',
      return: 'mobile-nav__return-btn',
      subNavActive: 'is-active',
      subNavClosing: 'is-closing',
      navOpen: 'js-menu--is-open',
      subNavShowing: 'sub-nav--is-open',
      thirdNavShowing: 'third-nav--is-open',
      subNavToggleBtn: 'js-toggle-submenu'
    };
    var cache = {};
    var isTransitioning;
    var $activeSubNav;
    var $activeTrigger;
    var menuLevel = 1;
    // Breakpoints from src/stylesheets/global/variables.scss.liquid
    var mediaQuerySmall = 'screen and (max-width: 749px)';
  
    function init() {
      cacheSelectors();
  
      cache.$mobileNavToggle.on('mousedown', toggleMobileNav);
      cache.$subNavToggleBtn.on('click.subNav', toggleSubNav);
  
      // Close mobile nav when unmatching mobile breakpoint
      enquire.register(mediaQuerySmall, {
        unmatch: function() {
          closeMobileNav();
        }
      });
    }
  
    function toggleMobileNav() {
      if (cache.$mobileNavToggle.hasClass(classes.mobileNavCloseIcon)) {
        closeMobileNav();
      } else {
        openMobileNav();
      }
    }
  
    function cacheSelectors() {
      cache = {
        $pageContainer: $('#PageContainer'),
        $siteHeader: $('.site-header'),
        $mobileNavToggle: $('.js-mobile-nav-toggle'),
        $mobileNavContainer: $('.mobile-nav-wrapper'),
        $mobileNav: $('#MobileNav'),
        $sectionHeader: $('#shopify-section-header'),
        $subNavToggleBtn: $('.' + classes.subNavToggleBtn)
      };
    }
  
    function openMobileNav() {
      var translateHeaderHeight =
        cache.$siteHeader.outerHeight() + cache.$siteHeader.position().top;
  
      cache.$mobileNavContainer.prepareTransition().addClass(classes.navOpen);
  
      cache.$mobileNavContainer.css({
        transform: 'translateY(' + translateHeaderHeight + 'px)'
      });
  
      cache.$pageContainer.css({
        transform:
          'translate3d(0, ' + cache.$mobileNavContainer[0].scrollHeight + 'px, 0)'
      });
  
      slate.a11y.trapFocus({
        $container: cache.$sectionHeader,
        $elementToFocus: cache.$mobileNav
          .find('.' + classes.navLinkWrapper + ':first')
          .find('.' + classes.navLink),
        namespace: 'navFocus'
      });
  
      cache.$mobileNavToggle
        .addClass(classes.mobileNavCloseIcon)
        .removeClass(classes.mobileNavOpenIcon);
  
      // close on escape
      $(window).on('keyup.mobileNav', function(evt) {
        if (evt.which === 27) {
          closeMobileNav();
        }
      });
    }
  
    function closeMobileNav() {
      cache.$mobileNavContainer.prepareTransition().removeClass(classes.navOpen);

      cache.$mobileNavContainer.css({
        transform: 'translateY(-100%)'
      });
  
      cache.$pageContainer.removeAttr('style');
  
      slate.a11y.trapFocus({
        $container: $('html'),
        $elementToFocus: $('body')
      });
  
      cache.$mobileNavContainer.one(
        'TransitionEnd.navToggle webkitTransitionEnd.navToggle transitionend.navToggle oTransitionEnd.navToggle',
        function() {
          slate.a11y.removeTrapFocus({
            $container: cache.$mobileNav,
            namespace: 'navFocus'
          });
          document.activeElement.blur();
        }
      );
  
      cache.$mobileNavToggle
        .addClass(classes.mobileNavOpenIcon)
        .removeClass(classes.mobileNavCloseIcon);
  
      $(window).off('keyup.mobileNav');
  
      scrollTo(0, 0);
    }
  
    function toggleSubNav(evt) {
      if (isTransitioning) {
        return;
      }
  
      var $toggleBtn = $(evt.currentTarget);
      var isReturn = $toggleBtn.hasClass(classes.return);
      isTransitioning = true;
  
      if (isReturn) {
        // Close all subnavs by removing active class on buttons
        $(
          '.' + classes.subNavToggleBtn + '[data-level="' + (menuLevel - 1) + '"]'
        ).removeClass(classes.subNavActive);
  
        if ($activeTrigger && $activeTrigger.length) {
          $activeTrigger.removeClass(classes.subNavActive);
        }
      } else {
        $toggleBtn.addClass(classes.subNavActive);
      }
  
      $activeTrigger = $toggleBtn;
  
      goToSubnav($toggleBtn.data('target'));
    }
  
    function goToSubnav(target) {
      /*eslint-disable shopify/jquery-dollar-sign-reference */
  
      var $targetMenu = target
        ? $('.mobile-nav__dropdown[data-parent="' + target + '"]')
        : cache.$mobileNav;
  
      menuLevel = $targetMenu.data('level') ? $targetMenu.data('level') : 1;
  
      if ($activeSubNav && $activeSubNav.length) {
        $activeSubNav.prepareTransition().addClass(classes.subNavClosing);
      }
  
      $activeSubNav = $targetMenu;
  
      var $elementToFocus = target
        ? $targetMenu.find('.' + classes.subNavLink + ':first')
        : $activeTrigger;
  
      /*eslint-enable shopify/jquery-dollar-sign-reference */
  
      var translateMenuHeight = $targetMenu.outerHeight();
  
      var openNavClass =
        menuLevel > 2 ? classes.thirdNavShowing : classes.subNavShowing;
  
      cache.$mobileNavContainer
        .css('height', translateMenuHeight)
        .removeClass(classes.thirdNavShowing)
        .addClass(openNavClass);
  
      if (!target) {
        // Show top level nav
        cache.$mobileNavContainer
          .removeClass(classes.thirdNavShowing)
          .removeClass(classes.subNavShowing);
      }
  
      // Focusing an item in the subnav early forces element into view and breaks the animation.
      cache.$mobileNavContainer.one(
        'TransitionEnd.subnavToggle webkitTransitionEnd.subnavToggle transitionend.subnavToggle oTransitionEnd.subnavToggle',
        function() {
          slate.a11y.trapFocus({
            $container: $targetMenu,
            $elementToFocus: $elementToFocus,
            namespace: 'subNavFocus'
          });
  
          cache.$mobileNavContainer.off('.subnavToggle');
          isTransitioning = false;
        }
      );
  
      // Match height of subnav
      cache.$pageContainer.css({
        transform: 'translateY(' + translateMenuHeight + 'px)'
      });
  
      $activeSubNav.removeClass(classes.subNavClosing);
    }
  
    return {
      init: init,
      closeMobileNav: closeMobileNav
    };
  })(jQuery);

// header.js
theme.ajaxCart = {
    init: function() {
        CartJS.init(cartJSON, {
            "requestBodyClass": "ajax-loading",
            "moneyFormat": theme.moneyFormat,
            "moneyWithCurrencyFormat": theme.moneyWithCurrencyFormat,
            "debug": true    
        });
        
        if($('.cart .inline-select, .cart-mini .inline-select').length) {
            this.populateSelects($('.cart .inline-select, .cart-mini .inline-select'));
        }

        this.listen();        
    },
    
    listen: function() {
        $(document).on('cart.requestComplete', function(event, cart) {
            theme.ajaxCart.updateCounter(cart.total_price);
            theme.ajaxCart.flash();
            theme.ajaxCart.populateSelects($('.cart .inline-select, .cart-mini .inline-select'));
        });

        $(document).on('change', '.cart .inline-select, .cart-mini .inline-select', function() {
            var unitType = $(this).attr('data-unit-type'),
                unitTypeSingular = $(this).attr('data-unit-type-singular'),
                unitOptions = $(this).attr('data-unit-options'),
                index = parseInt($(this).attr('data-index')),
                quantity = parseInt($(this).val());

            theme.ajaxCart.updateItem({
                index: index, 
                quantity: quantity,
                unitType: unitType,
                unitTypeSingular: unitTypeSingular,
                unitOptions: unitOptions
            });
        });

        $('.add-product').on('click', function(e) {
            e.preventDefault();
            var form = $(this).closest('form'),
                quantity = $(form).find('[data-product-quantity]').val(),
                id = $(form).find('[data-product-select]').val(),
                unitType = $(form).find('#unit_type_property').val(),
                unitTypeSingular = $(form).find('#unit_type_property_singular').val(),
                unitOptions = $(form).find('#unit_options_property').val(),
                unitQuantity = $(form).find('#quantity_property').val();
                // index = parseInt($(this).attr('data-index')),
                // value = parseInt($(this).val()),

            var foundItem = theme.ajaxCart.findInCart(id);

            if(foundItem.length > 0) {
                theme.ajaxCart.updateItem({
                    index: (foundItem[0].index + 1), 
                    quantity: (parseInt(foundItem[0].item.quantity) + parseInt(quantity)),
                    unitType: unitType,
                    unitTypeSingular: unitTypeSingular,
                    unitOptions: unitOptions
                });
            } else {
                theme.ajaxCart.add({
                    id: id, 
                    qty: parseInt(quantity),
                    unitQuantity: unitQuantity,
                    unitType: unitType,
                    unitTypeSingular: unitTypeSingular,
                    unitOptions: unitOptions
                });
            }
        });
    },

    flash: function() {
        $('.site-navigation__cart, .mobile-navigation__cart').addClass('flash');
        setTimeout(function() {
            $('.site-navigation__cart, .mobile-navigation__cart').removeClass('flash');
        }, 500);
    },

    findInCart: function(currentId) {
        var inCart = [];
        
        CartJS.cart.items.forEach(function(element, index) {
            if (element.id == parseInt(currentId)) {
                inCart.push({"item": element, "index": index });
            }
        });

        return inCart;
    },

    updateCounter: function(total) {
        if (total == 0) {
            var newTotal = slate.Currency.formatMoney(total, "{{amount_no_decimals}}€");
        } else {
            var newTotal = slate.Currency.formatMoney(total, theme.moneyFormat);
        }

        $(".site-navigation__cart-counter").html(newTotal);
        $(".mobile-navigation__cart-counter").html(newTotal);
    },

    populateSelects: function(selects) {
        $(selects).each(function(i, select) {
            var selectOptions = $(select).attr('data-unit-options').split(','),
                type = $(select).attr('data-unit-type'),
                quantity = $(select).attr('data-quantity'),
                optEl = [],
                highestOption = Math.max.apply(null, selectOptions);

            var optEl = selectOptions.map(function(num, i) {
                return '<option value="'+ num.replace(/ /g,'') +'">' + num + ' ' + type + '</option>';   
            });

            if (quantity > highestOption) {
              optEl.push('<option value="' + quantity + '">' + quantity + ' ' + type + '</option>');
            }
            
            $(select).empty()
                    .append(optEl)
                    .val(quantity);
        });
    },

    add: function(item) {
        CartJS.addItem(item.id, item.qty, {
            "_unit_options": item.unitOptions,
            "_unit_type": item.unitType,
            "_unit_type_singular": item.unitTypeSingular,
            "qty": item.quantity + ' ' + item.unitType            
        });
    },

    // remove: function() {

    // },

    // updateItemById: function(options) {
    //     CartJS.updateItem(options.id, options.qty, {
    //         "qty": options.qty + ' ' + options.unitType
    //     });
    // },

    updateItem: function(item) {
        CartJS.updateItem(item.index, item.quantity, {
            "_unit_options": item.unitOptions,
            "_unit_type": item.unitType,
            "_unit_type_singular": item.unitTypeSingular,
            "qty": item.quantity + ' ' + item.unitType
        });
    }
};

theme.Slideshow = (function() {
  this.$slideshow = null;
  var classes = {
    wrapper: 'slideshow-wrapper',
    slideshow: 'slideshow',
    currentSlide: 'slick-current',
    // video: 'slideshow__video',
    // videoBackground: 'slideshow__video--background',
    // closeVideoBtn: 'slideshow__video-control--close',
    pauseButton: 'slideshow__pause',
    isPaused: 'is-paused'
  };

  function slideshow(el) {
    this.$slideshow = $(el);
    this.$wrapper = this.$slideshow.closest('.' + classes.wrapper);
    this.$pause = this.$wrapper.find('.' + classes.pauseButton);
    this.settings = {
      accessibility: true,
      arrows: false,
      dots: true,
      fade: false,
      infinite: false,
      draggable: true,
      touchThreshold: 20,
      autoplay: this.$slideshow.data('autoplay'),
      autoplaySpeed: this.$slideshow.data('speed')
    };

    this.$slideshow.on('beforeChange', beforeChange.bind(this));
    this.$slideshow.on('init', slideshowA11y.bind(this));
    this.$slideshow.on('init', slideshowIntro.bind(this));
    this.$slideshow.slick(this.settings);

    // this.$pause.on('click', this.togglePause.bind(this));
  }

  function slideshowIntro(event, obj) {
    $slider = obj.$slider;

    if ( $slider.hasClass('slideshow--intro') ) {
      setTimeout(function() {
        $slider.removeClass('slideshow--intro');
      }, 1000);
    }
  }

  function slideshowA11y(event, obj) {
    var $slider = obj.$slider;
    var $list = obj.$list;
    var $wrapper = this.$wrapper;
    var autoplay = this.settings.autoplay;

    // Remove default Slick aria-live attr until slider is focused
    $list.removeAttr('aria-live');

    // When an element in the slider is focused
    // pause slideshow and set aria-live.
    $wrapper.on('focusin', function(evt) {
      if (!$wrapper.has(evt.target).length) {
        return;
      }

      $list.attr('aria-live', 'polite');

      if (autoplay) {
        $slider.slick('slickPause');
      }
    });

    // Resume autoplay
    $wrapper.on('focusout', function(evt) {
      if (!$wrapper.has(evt.target).length) {
        return;
      }

      $list.removeAttr('aria-live');

      if (autoplay) {
        // Manual check if the focused element was the video close button
        // to ensure autoplay does not resume when focus goes inside YouTube iframe
        if ($(evt.target).hasClass(classes.closeVideoBtn)) {
          return;
        }

        $slider.slick('slickPlay');
      }
    });

    // Add arrow key support when focused
    if (obj.$dots) {
      obj.$dots.on('keydown', function(evt) {
        if (evt.which === 37) {
          $slider.slick('slickPrev');
        }

        if (evt.which === 39) {
          $slider.slick('slickNext');
        }

        // Update focus on newly selected tab
        if ((evt.which === 37) || (evt.which === 39)) {
          obj.$dots.find('.slick-active button').focus();
        }
      });
    }
  }

  function beforeChange(event, slick, currentSlide, nextSlide) {
  //   var $slider = slick.$slider;
  //   var $currentSlide = $slider.find('.' + classes.currentSlide);
  //   var $nextSlide = $slider.find('.slideshow__slide[data-slick-index="' + nextSlide + '"]');

    // if (isVideoInSlide($currentSlide)) {
    //   var $currentVideo = $currentSlide.find('.' + classes.video);
    //   var currentVideoId = $currentVideo.attr('id');
    //   theme.SlideshowVideo.pauseVideo(currentVideoId);
    //   $currentVideo.attr('tabindex', '-1');
    // }

    // if (isVideoInSlide($nextSlide)) {
    //   var $video = $nextSlide.find('.' + classes.video);
    //   var videoId = $video.attr('id');
    //   var isBackground = $video.hasClass(classes.videoBackground);
    //   if (isBackground) {
    //     theme.SlideshowVideo.playVideo(videoId);
    //   } else {
    //     $video.attr('tabindex', '0');
    //   }
    // }
  }

  // function isVideoInSlide($slide) {
  //   return $slide.find('.' + classes.video).length;
  // }

  slideshow.prototype.togglePause = function() {
    var slideshowSelector = getSlideshowId(this.$pause);
    if (this.$pause.hasClass(classes.isPaused)) {
      this.$pause.removeClass(classes.isPaused);
      $(slideshowSelector).slick('slickPlay');
    } else {
      this.$pause.addClass(classes.isPaused);
      $(slideshowSelector).slick('slickPause');
    }
  };

  function getSlideshowId($el) {
    return '#Slideshow-' + $el.data('id');
  }

  return slideshow;
})();


theme.Intro = {
    init: function() {
        this.hideIntro();
    },

    hideIntro: function() {
        setTimeout(function() {
            $('.intro').addClass('intro--hidden');
        }, 2000);
    }
};
// https://help.shopify.com/themes/customization/store/enable-autocomplete-for-search-boxes#create-a-snippet


theme.Search = {
	init: function() {
		theme.Search.listen();
	},
	
	currentAjaxRequest: null,
	activeSearch: false,
	term: '',
	
	listen: function() {
		$('.site-navigation__search a').on('click', function(e) {
			e.preventDefault();
			theme.Search.showSearch();
			
			// if (theme.Search.term.length > 3) {
			// 	theme.Search.showResults();
			// }
		});
		
		$('body').bind('click', function(e){
			if ( $(e.target).closest('.site-navigation__search').length <= 0 && theme.Search.activeSearch && $(e.target).closest('.search-autocomplete__results').length <= 0 ) {
				theme.Search.hideSearch();
				// theme.Search.hideResults();
				// $('.search-autocomplete__results').hide();
			}
		});

		// $('body').on('keyup', function(e) {
		// 	if(e.which == 27 && theme.Search.activeSearch ) {
		// 		theme.Search.hideSearch();
		// 	}
		// });

		// $('#header-search').attr('autocomplete', 'off').bind('keyup change', function(e) {
		// 	if(e.which == 27 && theme.Search.activeSearch ) {
		// 		theme.Search.hideSearch();
		// 	}
		// 	theme.Search.trigger($(this));
		// 	// theme.search.setPosition($(this));
		// });
		
		// Clicking outside makes the results disappear.
		// $('body').bind('click', function(){
		// 	console.log('asdfd');
		// 	// theme.Search.hideSearch();
		// 	$('.search-autocomplete__results').hide();
		// });
	},

	showSearch: function() {
        theme.Search.activeSearch = true;
		$('.site-navigation--right').addClass('site-navigation--active-search');
        setTimeout(function() {
            $('.site-navigation__search #header-search').focus();
        }, 100);
    },

    hideSearch: function() {
        theme.Search.activeSearch = false;
        $('.site-navigation--right').removeClass('site-navigation--active-search');
    },

	// setPosition: function(input) {
	// 	var newTop = $(input).position().top + input.innerHeight() + 1;
	// 	console.log(newTop);
	// 	$('.search-autocomplete__results').css('top', newTop);
	// },

	trigger: function(input) {	
		var value = $(input).val();
		// If that's a new term and it contains at least 3 characters.
		// if (term.length > 3 && term != $(input).attr('data-old-term')) {

		if (value.length > 3 && value != theme.Search.term) {
			// Saving old query.
			// theme.Search.saveOldTerm(input, theme.Search.term);
			theme.Search.term = value;
			theme.Search.makeRequest();
			
		} else if (theme.Search.term !== '') {
			theme.Search.term = '';
			theme.Search.emptyResult();
		} else {
			theme.Search.emptyResult();
		}
	},

	// saveOldTerm: function(input, term) {
	// 	$(input).attr('data-old-term', term);
	// },

	makeRequest: function() {
		var url = '/search?type=product&q=' + theme.Search.term;

		// Killing any Ajax request that's currently being processed.
		if (theme.Search.currentAjaxRequest != null) {
			theme.Search.currentAjaxRequest.abort();
		}

		// Pulling results.
		theme.Search.currentAjaxRequest = $.getJSON(url + '&view=json', function(data) {
			theme.Search.gotResults(data, url);
		});
	},

	gotResults: function(data, url) {
		var resultsList = $('.search-autocomplete__results');
		
		// Reset results.
		theme.Search.populateResult('');
		// If we have no results.
		if(data.results_count == 0) {
			theme.Search.appendResults(resultsList);
			// resultsList.hide();
		} else {
			// If we have results.
			theme.Search.appendResults(data, resultsList);
			// The Ajax request will return at the most 10 results.
			// If there are more than 8, let's link to the search results page.
			if(data.results_count > 10) {
				theme.Search.populateResult('<li><span class="result-all result-title"><a href="' + url + '">See all results (' + data.results_count + ')</a></span></li>');
				// resultsList.append('<li><span class="result-all result-title"><a href="' + url + '">See all results (' + data.results_count + ')</a></span></li>');
			}
			theme.Search.showResults();
		}  
	},

	noResults: function(resultsList) {
		resultsList.html('<li><span class="title">No results.</span></li>');
		theme.Search.showResults();
	},

	populateResult: function(data) {
		$('.search-autocomplete__results').append(data);
	},

	emptyResult: function(data) {
		$('.search-autocomplete__results').empty();
	},

	showResults: function() {
		// setTimeout(function() {
		// }, 100);
		$('.search-autocomplete__results').fadeIn(700);
	},
	
	hideResults: function() {
		$('.search-autocomplete__results').hide(300);
	},

	appendResults: function(data, resultsList) {
		$.each(data.results, function(index, item) {
			var link = $('<a class="clearfix"></a>').attr('href', item.url);
			
			link.append('<span class="thumbnail"><img src="' + item.thumbnail + '" /></span>');
			link.append('<span class="result-title">' + item.title + '</span>');
			link.wrap('<li></li>');

			theme.Search.populateResult(link.parent());
		});
	}
};




	// Current Ajax request.
	// var currentAjaxRequest = null;
	// Grabbing all search forms on the page, and adding a .search-results list to each.
	// var searchForms = $('form[action="/search"]').css('position','relative').each(function() {
	// var searchForms = $('.site-header form[action="/search"]').each(function() {
		// Grabbing text input.
		// var input = $(this).find('input[name="q"]');
		// Adding a list for showing search results.
		// var offSet = input.position().top + input.innerHeight();
		// $('<ul class="search-results"></ul>').css({ 
		// 	'position': 'absolute', 
		// 	'right': '0px', 
		// 	'top': offSet + 1
		// }).appendTo($(this)).hide();    

		// Listening to keyup and change on the text field within these search forms.
		// input.attr('autocomplete', 'off').bind('keyup change', function() {
			// // What's the search term?
			// var term = $(this).val();
			// // What's the search form?
			// var form = $(this).closest('form');
			// // What's the search URL?
			// var searchURL = '/search?type=product&q=' + term;
			// // What's the search results list?
			// var resultsList = form.find('.search-results');
			
			// // If that's a new term and it contains at least 3 characters.
			// if (term.length > 3 && term != $(this).attr('data-old-term')) {
			// 	// Saving old query.
			// 	$(this).attr('data-old-term', term);
			// 	// Killing any Ajax request that's currently being processed.
			// 	if (currentAjaxRequest != null) currentAjaxRequest.abort();
			// 	// Pulling results.
			// 	currentAjaxRequest = $.getJSON(searchURL + '&view=json', function(data) {
			// 		// Reset results.
			// 		resultsList.empty();
			// 		// If we have no results.
			// 		if(data.results_count == 0) {
			// 			// resultsList.html('<li><span class="title">No results.</span></li>');
			// 			// resultsList.fadeIn(200);
			// 			resultsList.hide();
			// 		} else {
			// 			// If we have results.
			// 			$.each(data.results, function(index, item) {
			// 				var link = $('<a class="cf"></a>').attr('href', item.url);
			// 				link.append('<span class="thumbnail"><img src="' + item.thumbnail + '" /></span>');
			// 				link.append('<span class="result-title">' + item.title + '</span>');
			// 				link.wrap('<li></li>');
			// 				resultsList.append(link.parent());
			// 			});
			// 			// The Ajax request will return at the most 10 results.
			// 			// If there are more than 10, let's link to the search results page.
			// 			if(data.results_count > 10) {
			// 				resultsList.append('<li><span class="result-all result-title"><a href="' + searchURL + '">See all results (' + data.results_count + ')</a></span></li>');
			// 			}
			// 			resultsList.fadeIn(200);
			// 		}        
			// 	});
			// }
		// });
	// });
	
	

theme.Search = (function() {
    var selectors = {
      search: '.search',
      searchSubmit: '.search__submit',
      searchInput: '.search__input',
  
      siteHeader: '.site-header',
      siteHeaderSearchToggle: '.site-header__search-toggle',
      siteHeaderSearch: '.site-header__search',
  
      searchDrawer: '.search-bar',
      searchDrawerInput: '.search-bar__input',
  
      searchHeader: '.search-header',
      searchHeaderInput: '.search-header__input',
      searchHeaderSubmit: '.search-header__submit',
  
      mobileNavWrapper: '.mobile-nav-wrapper'
    };
  
    var classes = {
      focus: 'search--focus',
      mobileNavIsOpen: 'js-menu--is-open'
    };
  
    function init() {
      if (!$(selectors.siteHeader).length) {
        return;
      }
  
      initDrawer();
      searchSubmit();
  
      $(selectors.searchHeaderInput)
        .add(selectors.searchHeaderSubmit)
        .on('focus blur', function() {
          $(selectors.searchHeader).toggleClass(classes.focus);
        });
  
      $(selectors.siteHeaderSearchToggle).on('click', function() {
        var searchHeight = $(selectors.siteHeader).outerHeight();
        var searchOffset = $(selectors.siteHeader).offset().top - searchHeight;
  
        $(selectors.searchDrawer).css({
          height: searchHeight + 'px',
          top: searchOffset + 'px'
        });
      });
    }
  
    function initDrawer() {
      // Add required classes to HTML
      $('#PageContainer').addClass('drawer-page-content');
      $('.js-drawer-open-top')
        .attr('aria-controls', 'SearchDrawer')
        .attr('aria-expanded', 'false');
  
      theme.SearchDrawer = new theme.Drawers('SearchDrawer', 'top', {
        onDrawerOpen: searchDrawerFocus
      });
    }
  
    function searchDrawerFocus() {
      searchFocus($(selectors.searchDrawerInput));
  
      if ($(selectors.mobileNavWrapper).hasClass(classes.mobileNavIsOpen)) {
        theme.MobileNav.closeMobileNav();
      }
    }
  
    function searchFocus($el) {
      $el.focus();
      // set selection range hack for iOS
      $el[0].setSelectionRange(0, $el[0].value.length);
    }
  
    function searchSubmit() {
      $(selectors.searchSubmit).on('click', function(evt) {
        var $el = $(evt.target);
        var $input = $el.parents(selectors.search).find(selectors.searchInput);
        if ($input.val().length === 0) {
          evt.preventDefault();
          searchFocus($input);
        }
      });
    }
  
    return {
      init: init
    };
  })();
// filter.js
theme.Filter = {
    init: function() {
        this.listen();
    },

    listen: function() {
        $('.filter__trigger').on('click', function(e) {
            console.log(e);
            console.log('open filter');
            theme.Filter.show(e);
        });
        // $('.filter__trigger').on('click', theme.Filter.show);
        $('.filter__close').on('click', function(e) {
            console.log('close filter')
            theme.Filter.hide(e);
        });

        // $('.filter__word').on('mouseover', function() {
        //     // $(this).closest('.filter__wrapper').addClass('filter--open');
        //     theme.Filter.show('filter__type');
        // });

        // $('.filter__word').closest('.filter__wrapper').on('mouseout', function() {
        //     console.log('oooutt');
        //     // $(this).closest('.filter__wrapper').addClass('filter--open');
        // });

        // $('.filter--open').on('mouseout', function() {
        //     console.log('sdfdsaf');
        //     console.log($(this).find('.filter__word'));
        //     // theme.Filter.hide($(this).find('.filter__word').attr('data-filter-show'));
        // });
        $('.touchevents .filter__wrapper--mobile .filter__trigger').on('click', function(e) {
            e.preventDefault();
            theme.Filter.toggle($(this))
        });

    },

    toggle: function(trigger) {
        // e.preventDefault();
        $(trigger).siblings('.filter__content').toggleClass('active');
        // $('.filter').toggleClass('filter--visible');
    },

    show: function(e) {
        e.preventDefault();
        console.log($('.filter'));
        $('.filter').addClass('filter--visible');
    },
    
    hide: function(e) {
        e.preventDefault();
        $('.filter').removeClass('filter--visible');
    }
}
// instafeed.js
theme.Instafeed = {
	el: $('#instafeed'),

	options: {
		get: 'user',
		limit: 10,
		resolution: 'standard_resolution',
		accessToken: "2272437676.1677ed0.1335b5a7c10a40d59877c7786ef90f46",
		userId: "2272437676",
		mock: true,
		success: function(response) {
			response.data.forEach(function(item) {
				theme.Instafeed.template(item);
			});
			theme.Instafeed.initSlider();
		}
	},

	init: function() {
		if( this.el ) {
			new Instafeed(this.options).run();
		}
	},

	template: function(item) {
		var caption = (item.caption.text.length > 120) ? item.caption.text.substring(0,120)+'...' : item.caption.text;
		var el = '<div class="instafeed--item">' +
					'<a href="'+ item.link +'" target="_blank" rel="noreferrer" title="'+ caption +'">' +
						'<img src="'+ item.images.standard_resolution.url +'" alt="'+ caption +'" />' +
					'</a>'+
					'<a class="instafeed--item-caption" target="_blank" rel="noreferrer" href="'+ item.link +'">'+
						'<div>'+ caption +'</div>'+
					'</a>'+
				'</div>';
	
		this.el.append(el);
	},

	initSlider: function() {
		this.el.slick({
			dots: false,
			infinite: false,
			speed: 300,
			slidesToShow: 5,
			slidesToScroll: 2,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 3
					}
				},
				{
					breakpoint: 600,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2
					}
				}
			]
		});
	}
};

/**
 * Module to add a shipping rates calculator to cart page.
 *
 * Copyright (c) 2011-2016 Caroline Schnapp (11heavens.com)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 * Modified by David Little, 2016
 */

"object" == typeof Countries && (Countries.updateProvinceLabel = function(e, t) {
    if ("string" == typeof e && Countries[e] && Countries[e].provinces) {
        if ("object" != typeof t && (t = document.getElementById("address_province_label"), null === t)) return;
        t.innerHTML = Countries[e].label;
        var r = jQuery(t).parent();
        r.find("select");
        r.find(".custom-style-select-box-inner").html(Countries[e].provinces[0])
    }
}), "undefined" == typeof Shopify.Cart && (Shopify.Cart = {}), Shopify.Cart.ShippingCalculator = function() {
    var _config = {
            submitButton: "Calculate shipping",
            submitButtonDisabled: "Calculating...",
            templateId: "shipping-calculator-response-template",
            wrapperId: "wrapper-response",
            customerIsLoggedIn: !1,
            moneyFormat: "${{amount}}"
        },
        _render = function(e) {
            var t = jQuery("#" + _config.templateId),
                r = jQuery("#" + _config.wrapperId);
            if (t.length && r.length) {
                var templateSettings = {
                    evaluate: /<%([\s\S]+?)%>/g,
                    interpolate: /<%=([\s\S]+?)%>/g,
                    escape: /<%-([\s\S]+?)%>/g
                };
                var n = Handlebars.compile(jQuery.trim(t.text())),
                    a = n(e);
                if (jQuery(a).appendTo(r), "undefined" != typeof Currency && "function" == typeof Currency.convertAll) {
                    var i = "";
                    jQuery("[name=currencies]").size() ? i = jQuery("[name=currencies]").val() : jQuery("#currencies span.selected").size() && (i = jQuery("#currencies span.selected").attr("data-currency")), "" !== i && Currency.convertAll(shopCurrency, i, "#wrapper-response span.money, #estimated-shipping span.money")
                }
            }
        },
        _enableButtons = function() {
            jQuery(".get-rates").removeAttr("disabled").removeClass("disabled").val(_config.submitButton)
        },
        _disableButtons = function() {
            jQuery(".get-rates").val(_config.submitButtonDisabled).attr("disabled", "disabled").addClass("disabled")
        },
        _getCartShippingRatesForDestination = function(e) {
            var t = {
                type: "POST",
                url: "/cart/prepare_shipping_rates",
                data: jQuery.param({
                    shipping_address: e
                }),
                success: _pollForCartShippingRatesForDestination(e),
                error: _onError
            };
            jQuery.ajax(t)
        },
        _pollForCartShippingRatesForDestination = function(e) {
            var t = function() {
                jQuery.ajax("/cart/async_shipping_rates", {
                    dataType: "json",
                    success: function(r, n, a) {
                        200 === a.status ? _onCartShippingRatesUpdate(r.shipping_rates, e) : setTimeout(t, 500)
                    },
                    error: _onError
                })
            };
            return t
        },
        _fullMessagesFromErrors = function(e) {
            var t = [];
            return jQuery.each(e, function(e, r) {
                jQuery.each(r, function(r, n) {
                    t.push(e + " " + n)
                })
            }), t
        },
        _onError = function(XMLHttpRequest, textStatus) {
            jQuery("#estimated-shipping").hide(), jQuery("#estimated-shipping em").empty(), _enableButtons();
            var feedback = "",
                data = eval("(" + XMLHttpRequest.responseText + ")");
            feedback = data.message ? data.message + "(" + data.status + "): " + data.description : "Error : " + _fullMessagesFromErrors(data).join("; ") + ".", "Error : country is not supported." === feedback && (feedback = "We do not ship to this destination."), _render({
                rates: [],
                errorFeedback: feedback,
                success: !1
            }), jQuery("#" + _config.wrapperId).show()
        },
        _onCartShippingRatesUpdate = function(e, t) {
            _enableButtons();
            _hideForm();
            _updateTotal(e[0].price);
            var r = "";
            if (t.zip && (r += t.zip + ", "), t.province && (r += t.province + ", "), r += t.country, e.length) {
                "0.00" == e[0].price ? jQuery("#estimated-shipping em").html("FREE") : jQuery("#estimated-shipping em").html(_formatRate(e[0].price));
                for (var n = 0; n < e.length; n++) e[n].price = _formatRate(e[n].price)
            }
            _render({
                rates: e,
                address: r,
                success: !0
            }), jQuery("#" + _config.wrapperId + ", #estimated-shipping").fadeIn()
        },

        _hideForm = function() {
            var isChecked = jQuery('#toggle-shipping').attr('checked');
            jQuery('#toggle-shipping').attr('checked', false);
        },

        _updateTotal = function(shippingPrice) {
            var subtotal = jQuery("#subtotal-price").attr("data-price");
            var total = jQuery("#total-price");
            var position = subtotal.length - 2;
            var output = [subtotal.slice(0, position), ".", subtotal.slice(position)].join('');
            var totalPrice = parseFloat(shippingPrice) + parseFloat(output);


            total.html( _formatRate(totalPrice.toFixed(2)) )
        },

        _formatRate = function(e) {
            function t(e, t) {
                return "undefined" == typeof e ? t : e
            }

            function r(e, r, n, a) {
                if (r = t(r, 2), n = t(n, ","), a = t(a, "."), isNaN(e) || null == e) return 0;
                e = (e / 100).toFixed(r);
                var i = e.split("."),
                    o = i[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + n),
                    s = i[1] ? a + i[1] : "";
                return o + s
            }
            if ("function" == typeof Shopify.formatMoney) return Shopify.formatMoney(e, _config.moneyFormat);
            "string" == typeof e && (e = e.replace(".", ""));
            var n = "",
                a = /\{\{\s*(\w+)\s*\}\}/,
                i = _config.moneyFormat;
            switch (i.match(a)[1]) {
                case "amount":
                    n = r(e, 2);
                    break;
                case "amount_no_decimals":
                    n = r(e, 0);
                    break;
                case "amount_with_comma_separator":
                    n = r(e, 2, ".", ",");
                    break;
                case "amount_no_decimals_with_comma_separator":
                    n = r(e, 0, ".", ",")
            }
            return i.replace(a, n)
        };
    return _init = function() {
        new Shopify.CountryProvinceSelector("address_country", "address_province", {
            hideElement: "address_province_container"
        });
        var e = jQuery("#address_country"),
            t = jQuery("#address_province_label").get(0);
        "undefined" != typeof Countries && (Countries.updateProvinceLabel(e.val(), t), e.change(function() {
            Countries.updateProvinceLabel(e.val(), t)
        })), jQuery(".get-rates").click(function() {
            _disableButtons(), jQuery("#" + _config.wrapperId).empty().hide();
            var e = {};
            e.zip = jQuery("#address_zip").val() || "", e.country = jQuery("#address_country").val() || "", e.province = jQuery("#address_province").val() || "", _getCartShippingRatesForDestination(e)
        }), _config.customerIsLoggedIn && jQuery(".get-rates:eq(0)").trigger("click")
    }, {
        show: function(e) {
            e = e || {}, jQuery.extend(_config, e), jQuery(function() {
                _init()
            })
        },
        getConfig: function() {
            return _config
        },
        formatRate: function(e) {
            return _formatRate(e)
        }
    }
}();




// /**
//  * Module to add a shipping rates calculator to cart page.
//  *
//  * Copyright (c) 2011-2016 Caroline Schnapp (11heavens.com)
//  * Dual licensed under the MIT and GPL licenses:
//  * http://www.opensource.org/licenses/mit-license.php
//  * http://www.gnu.org/licenses/gpl.html
//  * Modified by David Little, 2016
//  */

// "object"==typeof Countries&&(Countries.updateProvinceLabel=function(e,t){if("string"==typeof e&&Countries[e]&&Countries[e].provinces){if("object"!=typeof t&&(t=document.getElementById("address_province_label"),null===t))return;t.innerHTML=Countries[e].label;var r=jQuery(t).parent();r.find("select");r.find(".custom-style-select-box-inner").html(Countries[e].provinces[0])}}),"undefined"==typeof Shopify.Cart&&(Shopify.Cart={}),Shopify.Cart.ShippingCalculator=function(){var _config={submitButton:"Calculate shipping",submitButtonDisabled:"Calculating...",templateId:"shipping-calculator-response-template",wrapperId:"wrapper-response",customerIsLoggedIn:!1,moneyFormat:"${{amount}}"},_render=function(e){var t=jQuery("#"+_config.templateId),r=jQuery("#"+_config.wrapperId);if(t.length&&r.length){var templateSettings={evaluate:/<%([\s\S]+?)%>/g,interpolate:/<%=([\s\S]+?)%>/g,escape:/<%-([\s\S]+?)%>/g};var n=Handlebars.compile(jQuery.trim(t.text())),a=n(e);if(jQuery(a).appendTo(r),"undefined"!=typeof Currency&&"function"==typeof Currency.convertAll){var i="";jQuery("[name=currencies]").size()?i=jQuery("[name=currencies]").val():jQuery("#currencies span.selected").size()&&(i=jQuery("#currencies span.selected").attr("data-currency")),""!==i&&Currency.convertAll(shopCurrency,i,"#wrapper-response span.money, #estimated-shipping span.money")}}},_enableButtons=function(){jQuery(".get-rates").removeAttr("disabled").removeClass("disabled").val(_config.submitButton)},_disableButtons=function(){jQuery(".get-rates").val(_config.submitButtonDisabled).attr("disabled","disabled").addClass("disabled")},_getCartShippingRatesForDestination=function(e){var t={type:"POST",url:"/cart/prepare_shipping_rates",data:jQuery.param({shipping_address:e}),success:_pollForCartShippingRatesForDestination(e),error:_onError};jQuery.ajax(t)},_pollForCartShippingRatesForDestination=function(e){var t=function(){jQuery.ajax("/cart/async_shipping_rates",{dataType:"json",success:function(r,n,a){200===a.status?_onCartShippingRatesUpdate(r.shipping_rates,e):setTimeout(t,500)},error:_onError})};return t},_fullMessagesFromErrors=function(e){var t=[];return jQuery.each(e,function(e,r){jQuery.each(r,function(r,n){t.push(e+" "+n)})}),t},_onError=function(XMLHttpRequest,textStatus){jQuery("#estimated-shipping").hide(),jQuery("#estimated-shipping em").empty(),_enableButtons();var feedback="",data=eval("("+XMLHttpRequest.responseText+")");feedback=data.message?data.message+"("+data.status+"): "+data.description:"Error : "+_fullMessagesFromErrors(data).join("; ")+".","Error : country is not supported."===feedback&&(feedback="We do not ship to this destination."),_render({rates:[],errorFeedback:feedback,success:!1}),jQuery("#"+_config.wrapperId).show()},_onCartShippingRatesUpdate=function(e,t){_enableButtons();var r="";if(t.zip&&(r+=t.zip+", "),t.province&&(r+=t.province+", "),r+=t.country,e.length){"0.00"==e[0].price?jQuery("#estimated-shipping em").html("FREE"):jQuery("#estimated-shipping em").html(_formatRate(e[0].price));for(var n=0;n<e.length;n++)e[n].price=_formatRate(e[n].price)}_render({rates:e,address:r,success:!0}),jQuery("#"+_config.wrapperId+", #estimated-shipping").fadeIn()},_formatRate=function(e){function t(e,t){return"undefined"==typeof e?t:e}function r(e,r,n,a){if(r=t(r,2),n=t(n,","),a=t(a,"."),isNaN(e)||null==e)return 0;e=(e/100).toFixed(r);var i=e.split("."),o=i[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+n),s=i[1]?a+i[1]:"";return o+s}if("function"==typeof Shopify.formatMoney)return Shopify.formatMoney(e,_config.moneyFormat);"string"==typeof e&&(e=e.replace(".",""));var n="",a=/\{\{\s*(\w+)\s*\}\}/,i=_config.moneyFormat;switch(i.match(a)[1]){case"amount":n=r(e,2);break;case"amount_no_decimals":n=r(e,0);break;case"amount_with_comma_separator":n=r(e,2,".",",");break;case"amount_no_decimals_with_comma_separator":n=r(e,0,".",",")}return i.replace(a,n)};return _init=function(){new Shopify.CountryProvinceSelector("address_country","address_province",{hideElement:"address_province_container"});var e=jQuery("#address_country"),t=jQuery("#address_province_label").get(0);"undefined"!=typeof Countries&&(Countries.updateProvinceLabel(e.val(),t),e.change(function(){Countries.updateProvinceLabel(e.val(),t)})),jQuery(".get-rates").click(function(){_disableButtons(),jQuery("#"+_config.wrapperId).empty().hide();var e={};e.zip=jQuery("#address_zip").val()||"",e.country=jQuery("#address_country").val()||"",e.province=jQuery("#address_province").val()||"",_getCartShippingRatesForDestination(e)}),_config.customerIsLoggedIn&&jQuery(".get-rates:eq(0)").trigger("click")},{show:function(e){e=e||{},jQuery.extend(_config,e),jQuery(function(){_init()})},getConfig:function(){return _config},formatRate:function(e){return _formatRate(e)}}}();


/*================ Sections ================*/
/* eslint-disable no-new */
theme.Product = (function() {
  function Product(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');

    this.settings = {
      // Breakpoints from src/stylesheets/global/variables.scss.liquid
      mediaQueryMediumUp: 'screen and (min-width: 750px)',
      mediaQuerySmall: 'screen and (max-width: 749px)',
      bpSmall: false,
      enableHistoryState: $container.data('enable-history-state') || false,
      namespace: '.slideshow-' + sectionId,
      sectionId: sectionId,
      sliderActive: false,
      zoomEnabled: false
    };

    this.selectors = {
      addToCart: '#AddToCart-' + sectionId,
      addToCartText: '#AddToCartText-' + sectionId,
      comparePrice: '#ComparePrice-' + sectionId,
      originalPrice: '#ProductPrice-' + sectionId,
      SKU: '.variant-sku',
      originalPriceWrapper: '.product-price__price-' + sectionId,
      originalSelectorId: '#ProductSelect-' + sectionId,
      productImageWraps: '.product-single__photo',
      productPrices: '.product-single__price-' + sectionId,
      productThumbImages: '.product-single__thumbnail--' + sectionId,
      productThumbs: '.product-single__thumbnails-' + sectionId,
      saleClasses: 'product-price__sale product-price__sale--single',
      saleLabel: '.product-price__sale-label-' + sectionId,
      singleOptionSelector: '.single-option-selector-' + sectionId,
      // CUSTOM
      stockHolder: '.product-stockHolder-' + sectionId,
      productQuantity: '#Quantity'
      // END CUSTOM
    };

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$('#ProductJson-' + sectionId).html()) {
      return;
    }

    this.productSingleObject = JSON.parse(
      document.getElementById('ProductJson-' + sectionId).innerHTML
    );
    // CUSTOM
    this.productVariantSingleObject = JSON.parse(
      document.getElementById('ProductVariantJson-' + sectionId).innerHTML
    );
    // END CUSTOM

    this.settings.zoomEnabled = $(this.selectors.productImageWraps).hasClass(
      'js-zoom-enabled'
    );

    this._initBreakpoints();
    if ($(this.selectors.productThumbImages).length > 3) {
      this._initThumbnailSlider();
    }
    this._stringOverrides();
    // CUSTOM
    this._initVariantQuantity();
    // END CUSTOM
    this._initVariants();
    this._initImageSwitch();
    this._setActiveThumbnail();
  }

  // Product.prototype = _.assignIn({}, Product.prototype, {
  Product.prototype = $.extend({}, Product.prototype, {
    _stringOverrides: function() {
      theme.productStrings = theme.productStrings || {};
      $.extend(theme.strings, theme.productStrings);
    },

    _initBreakpoints: function() {
      var self = this;

      enquire.register(this.settings.mediaQuerySmall, {
        match: function() {
          // initialize thumbnail slider on mobile if more than three thumbnails
          // if ($(self.selectors.productThumbImages).length > 3) {
          //   self._initThumbnailSlider();
          // }

          // destroy image zooming if enabled
          if (self.settings.zoomEnabled) {
            $(self.selectors.productImageWraps).each(function() {
              _destroyZoom(this);
            });
          }

          self.settings.bpSmall = true;
        },
        unmatch: function() {
          // if (self.settings.sliderActive) {
          //   self._destroyThumbnailSlider();
          // }

          self.settings.bpSmall = false;
        }
      });

      enquire.register(this.settings.mediaQueryMediumUp, {
        match: function() {
          if (self.settings.zoomEnabled) {
            $(self.selectors.productImageWraps).each(function() {
              _enableZoom(this);
            });
          }

          // if ($(self.selectors.productThumbImages).length > 3) {
          //   self._initThumbnailSlider();
          // }

        }
      });
    },

    // ADD VARIANT QUANTITY
    _initVariantQuantity: function() {
      var self = this;

      this.productSingleObject.variants.map(function(variant) {
        var id = variant.id;
        return variant.inventory_quantity = self.productVariantSingleObject[id];
      }) 
    },

    _initVariants: function() {
      var options = {
        $container: this.$container,
        enableHistoryState:
          this.$container.data('enable-history-state') || false,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        product: this.productSingleObject,
        // CUSTOM
        product_variant: this.productVariantSingleObject
        // END CUSTOM
      };

      this.variants = new slate.Variants(options);

      this.$container.on(
        'variantChange' + this.settings.namespace,
        this._updateAddToCart.bind(this)
      );
      this.$container.on(
        'variantChange' + this.settings.namespace,
        this._updateStock.bind(this)
      );
      this.$container.on(
        'variantChange' + this.settings.namespace,
        this._updateMaxInput.bind(this)
      );
      this.$container.on(
        'variantImageChange' + this.settings.namespace,
        this._updateImages.bind(this)
      );
      this.$container.on(
        'variantPriceChange' + this.settings.namespace,
        this._updatePrice.bind(this)
      );
      this.$container.on(
        'variantSKUChange' + this.settings.namespace,
        this._updateSKU.bind(this)
      );
    },

    _initImageSwitch: function() {
      if (!$(this.selectors.productThumbImages).length) {
        return;
      }

      var self = this;

      $(this.selectors.productThumbImages).on('click', function(evt) {
        evt.preventDefault();
        var $el = $(this);

        var imageId = $el.data('thumbnail-id');

        self._switchImage(imageId);
        self._setActiveThumbnail(imageId);
      });
    },

    _setActiveThumbnail: function(imageId) {
      var activeClass = 'active-thumb';

      // If there is no element passed, find it by the current product image
      if (typeof imageId === 'undefined') {
        imageId = $(this.selectors.productImageWraps + ":not('.hide')").data(
          'image-id'
        );
      }

      var $thumbnail = $(
        this.selectors.productThumbImages +
          "[data-thumbnail-id='" +
          imageId +
          "']"
      );
      $(this.selectors.productThumbImages).removeClass(activeClass);
      $thumbnail.addClass(activeClass);
    },

    _switchImage: function(imageId) {
      var $newImage = $(
        this.selectors.productImageWraps + "[data-image-id='" + imageId + "']",
        this.$container
      );
      var $otherImages = $(
        this.selectors.productImageWraps +
          ":not([data-image-id='" +
          imageId +
          "'])",
        this.$container
      );
      $newImage.removeClass('hide');
      $otherImages.addClass('hide');
    },

    _initThumbnailSlider: function() {
      var options = {
        slidesToShow: 5,
        slidesToScroll: 3,
        arrows: true,
        infinite: false,
        // prevArrow: '.thumbnails-slider__prev--' + this.settings.sectionId,
        // nextArrow: '.thumbnails-slider__next--' + this.settings.sectionId,
        responsive: [
          {
            breakpoint: 550,
            settings: {
              slidesToShow: 4
            }
          },
          {
            breakpoint: 400,
            settings: {
              slidesToShow: 3
            }
          }
        ]
      };

      $(this.selectors.productThumbs).slick(options);
      this.settings.sliderActive = true;
    },

    _destroyThumbnailSlider: function() {
      $(this.selectors.productThumbs).slick('unslick');
      this.settings.sliderActive = false;
    },

    _updateAddToCart: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(this.selectors.productPrices)
          .removeClass('visibility-hidden')
          .attr('aria-hidden', 'true');

        if (variant.available) {
          $(this.selectors.addToCart).prop('disabled', false);
          $(this.selectors.addToCartText).text(theme.strings.addToCart);
        } else {
          // The variant doesn't exist, disable submit button and change the text.
          // This may be an error or notice that a specific variant is not available.
          $(this.selectors.addToCart).prop('disabled', true);
          $(this.selectors.addToCartText).text(theme.strings.soldOut);
        }
      } else {
        $(this.selectors.addToCart).prop('disabled', true);
        $(this.selectors.addToCartText).text(theme.strings.unavailable);
        $(this.selectors.productPrices)
          .addClass('visibility-hidden')
          .attr('aria-hidden', 'false');
      }
    },

    _updateImages: function(evt) {
      var variant = evt.variant;
      var imageId = variant.featured_image.id;

      this._switchImage(imageId);
      this._setActiveThumbnail(imageId);
    },

    // CUSTOM
    _updateStock: function(evt) {
      var currentStock = $(this.selectors.stockHolder).text();
      var number = parseInt(currentStock);
      var newStock = currentStock.replace(number, evt.variant.inventory_quantity);
      $(this.selectors.stockHolder).html(newStock);
      // $(this.selectors.stockHolder).html(evt.variant.inventory_quantity);

    },

    _updateMaxInput: function(evt) {
      var productQuantity = $(this.selectors.productQuantity);
      var variantQuantity = evt.variant.inventory_quantity;
      if(!variantQuantity || variantQuantity == 0) {
        productQuantity.attr('max', null);
      } else {
        productQuantity.attr('max', variantQuantity);
      }
      if(productQuantity.val() > variantQuantity && variantQuantity !== 0) {
        productQuantity.val(variantQuantity);
      }
      
    },
    // END CUSTOM

    _updatePrice: function(evt) {
      var variant = evt.variant;

      // Update the product price
      $(this.selectors.originalPrice).html(
        slate.Currency.formatMoney(variant.price, theme.moneyFormat)
        // theme.Currency.formatMoney(variant.price, theme.moneyFormat)
      );

      // Update and show the product's compare price if necessary
      if (variant.compare_at_price > variant.price) {
        $(this.selectors.comparePrice)
          .html(
            theme.Currency.formatMoney(
              variant.compare_at_price,
              theme.moneyFormat
            )
          )
          .removeClass('hide');

        $(this.selectors.originalPriceWrapper).addClass(
          this.selectors.saleClasses
        );

        $(this.selectors.saleLabel).removeClass('hide');
      } else {
        $(this.selectors.comparePrice).addClass('hide');
        $(this.selectors.saleLabel).addClass('hide');
        $(this.selectors.originalPriceWrapper).removeClass(
          this.selectors.saleClasses
        );
      }
    },

    _updateSKU: function(evt) {
      var variant = evt.variant;

      // Update the sku
      $(this.selectors.SKU).html(variant.sku);
    },

    onUnload: function() {
      this.$container.off(this.settings.namespace);
    }
  });

  function _enableZoom(el) {
    var zoomUrl = $(el).data('zoom');
    $(el).zoom({
      url: zoomUrl
    });
  }

  function _destroyZoom(el) {
    $(el).trigger('zoom.destroy');
  }

  return Product;
})();

theme.slideshows = {};

theme.SlideshowSection = (function() {
  function SlideshowSection(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var slideshow = this.slideshow = '#Slideshow-' + sectionId;

    // $('.slideshow__video', slideshow).each(function() {
    //   var $el = $(this);
    //   theme.SlideshowVideo.init($el);
    //   theme.SlideshowVideo.loadVideo($el.attr('id'));
    // });

    theme.slideshows[slideshow] = new theme.Slideshow(slideshow);
  }

  return SlideshowSection;
})();

// theme.SlideshowSection.prototype = _.assignIn({}, theme.SlideshowSection.prototype, {
theme.SlideshowSection.prototype = $.extend({}, theme.SlideshowSection.prototype, {
  onUnload: function() {
    delete theme.slideshows[this.slideshow];
  },

  onBlockSelect: function(evt) {
    var $slideshow = $(this.slideshow);

    // Ignore the cloned version
    var $slide = $('.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)');
    var slideIndex = $slide.data('slick-index');

    // Go to selected slide, pause autoplay
    $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
  },

  onBlockDeselect: function() {
    // Resume autoplay
    $(this.slideshow).slick('slickPlay');
  }
});
theme.intros = {};

theme.IntroSection = (function() {
  function IntroSection(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var intro = this.intro = '#Intro-' + sectionId;

    theme.intros[intro] = new theme.Intro(intro);
  }

  return IntroSection;
})();

// theme.IntroSection.prototype = _.assignIn({}, theme.IntroSection.prototype, {
theme.IntroSection.prototype = $.extend({}, theme.IntroSection.prototype, {
  onUnload: function() {
    delete theme.intros[this.intro];
  },

  onBlockSelect: function(evt) {
    var $intro = $(this.intro);

    // Ignore the cloned version
    var $slide = $('.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)');
    var slideIndex = $slide.data('slick-index');

    // Go to selected slide, pause autoplay
    $intro.slick('slickGoTo', slideIndex).slick('slickPause');
  },

  onBlockDeselect: function() {
    // Resume autoplay
    $(this.slideshow).slick('slickPlay');
  }
});
theme.Filters = (function() {
    var constants = {
      SORT_BY: 'sort_by'
    };
    var selectors = {
      filterSelection: '#SortTags',
      sortSelection: '#SortBy',
      defaultSort: '#DefaultSortBy'
    };
  
    function Filters(container) {
      var $container = (this.$container = $(container));
  
      this.$filterSelect = $(selectors.filterSelection, $container);
      this.$sortSelect = $(selectors.sortSelection, $container);
      this.$selects = $(selectors.filterSelection, $container).add(
        $(selectors.sortSelection, $container)
      );
  
      this.defaultSort = this._getDefaultSortValue();
      this._resizeSelect(this.$selects);
      this.$selects.removeClass('hidden');
  
      this.$filterSelect.on('change', this._onFilterChange.bind(this));
      this.$sortSelect.on('change', this._onSortChange.bind(this));
    }
  
    // Filters.prototype = _.assignIn({}, Filters.prototype, {
    Filters.prototype = $.extend({}, Filters.prototype, {
      _onSortChange: function(evt) {
        var sort = this._sortValue();
        if (sort.length) {
          window.location.search = sort;
        } else {
          // clean up our url if the sort value is blank for default
          window.location.href = window.location.href.replace(
            window.location.search,
            ''
          );
        }
        this._resizeSelect($(evt.target));
      },
  
      _onFilterChange: function(evt) {
        var filter = this._getFilterValue();
  
        // remove the 'page' parameter to go to the first page of results
        var search = document.location.search.replace(/\?(page=\w+)?&?/, '');
  
        // only add the search parameters to the url if they exist
        search = search !== '' ? '?' + search : '';
  
        document.location.href = filter + search;
        this._resizeSelect($(evt.target));
      },
  
      _getFilterValue: function() {
        return this.$filterSelect.val();
      },
  
      _getSortValue: function() {
        return this.$sortSelect.val() || this.defaultSort;
      },
  
      _getDefaultSortValue: function() {
        return $(selectors.defaultSort, this.$container).val();
      },
  
      _sortValue: function() {
        var sort = this._getSortValue();
        var query = '';
  
        if (sort !== this.defaultSort) {
          query = constants.SORT_BY + '=' + sort;
        }
  
        return query;
      },
  
      _resizeSelect: function($selection) {
        $selection.each(function() {
          var $this = $(this);
          var arrowWidth = 10;
          // create test element
          var text = $this.find('option:selected').text();
          var $test = $('<span>').html(text);
  
          // add to body, get width, and get out
          $test.appendTo('body');
          var width = $test.width();
          $test.remove();
  
          // set select width
          $this.width(width + arrowWidth);
        });
      },
  
      onUnload: function() {
        this.$filterSelect.off('change', this._onFilterChange);
        this.$sortSelect.off('change', this._onSortChange);
      }
    });
  
    return Filters;
  })();
theme.Cart = (function() {
    var selectors = {
      edit: '.js-edit-toggle'
    };
    var config = {
      showClass: 'cart__update--show',
      showEditClass: 'cart__edit--active',
      cartNoCookies: 'cart--no-cookies'
    };
  
    function Cart(container) {
      this.$container = $(container);
      this.$edit = $(selectors.edit, this.$container);
  
      if (!this.cookiesEnabled()) {
        this.$container.addClass(config.cartNoCookies);
      }
  
      this.$edit.on('click', this._onEditClick.bind(this));
    }
  
    Cart.prototype = _.assignIn({}, Cart.prototype, {
      onUnload: function() {
        this.$edit.off('click', this._onEditClick);
      },
  
      _onEditClick: function(evt) {
        var $evtTarget = $(evt.target);
        var $updateLine = $('.' + $evtTarget.data('target'));
  
        $evtTarget.toggleClass(config.showEditClass);
        $updateLine.toggleClass(config.showClass);
      },
  
      cookiesEnabled: function() {
        var cookieEnabled = navigator.cookieEnabled;
  
        if (!cookieEnabled) {
          document.cookie = 'testcookie';
          cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
        }
        return cookieEnabled;
      }
    });
  
    return Cart;
  })();
theme.HeaderSection = (function() {
    function Header() {
        theme.Header.init();
        theme.MobileNav.init();
        theme.Search.init();
    }
  
    Header.prototype = $.extend({}, Header.prototype, {
      onUnload: function() {
        theme.Header.unload();
      }
    });
  
    return Header;
  })();

/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();

// /**
//  * Customer Account Script
//  * ------------------------------------------------------------------------------
//  * A file that contains scripts highly couple code to the Customer Account
//  * template.
//  *
//  * @namespace customerAccount
//  */

// theme.customerAccount = (function() {
//     if($('#newsletter-check').length) {
//         // var customerEmail = $('#customerEmail').val();
//         // var customerEmailMD5 = $('#customerEmailMD5').val();
//         // var newsletterList = $('#newsletterList').val();
//         var options = {
//             "customerEmail": $('#customerEmail').val(),
//             "customerEmailMD5": $('#customerEmailMD5').val(),
//             "newsletterList": $('#newsletterList').val()
//         };
//         check(options);
//     }
    

//     function check(options) {
//         console.log(options);
//     }

// })();


$(document).ready(function() {
	var sections = new slate.Sections();

	sections.register('cart-template', theme.Cart);
	sections.register('product', theme.Product);
	sections.register('collection-template', theme.Filters);
	sections.register('product-template', theme.Product);
	sections.register('header-section', theme.HeaderSection);
	sections.register('map', theme.Maps);
	sections.register('slideshow', theme.SlideshowSection);
	sections.register('quotes', theme.Quotes);

	// sections.register('intro', theme.IntroSection);
	

	// Common a11y fixes
	slate.a11y.pageLinkFocus($(window.location.hash));

	$('.in-page-link').on('click', function(evt) {
		slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
	});

	// Wrap videos in div to force responsive layout.
	slate.rte.wrapTable();
	slate.rte.findYoutubeLinks();
	slate.rte.iframeReset();

	// Apply a specific class to the html element for browser support of cookies.
	if (slate.cart.cookiesEnabled()) {
		document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
	}

	// Check if browser supports mix-blend-mode
	if(typeof window.getComputedStyle(document.body).backgroundBlendMode == 'undefined') {
		document.documentElement.className += " no-background-blend-mode";
	}

	// Init functions
	theme.Instafeed.init();
	// theme.ajaxCart.init();

	// Main intro slideshow
	theme.Slideshow($('.slideshow'));

	$('.product-single__read-more a').on('click', function(e) {
		e.preventDefault();
		$('.product-single__description').toggleClass('open');
	});
	

	
	// Giftwrapping
	if($('#gift-wrapping').length) {
		if ( !$('#gift-wrapping').is(':checked') ) {
			$('#gift-message-wrapper').hide();
		}
		$('#gift-wrapping').on('click', function() {
			if ( $('#gift-wrapping').is(':checked') ) {
				$('#gift-message-wrapper').show();
			} else {
				$('#gift-message-wrapper').hide();
			}
		});
	}


	// Related products slider
	if($('.related-products').length) {
		$('.related-products .grid--view-items').slick({
			slidesToShow: 3,
			slidesToScroll: 2,
			dots: true,
			arrows: true,
			infinite: false,
			responsive: [
				{
					breakpoint: 1000,
					settings: {
						slidesToShow: 2
					}
				},
				{
					breakpoint: 400,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						arrows: false
					}
				}
			]
		});
	}


	// add _blank to all external links
	$('a[href^="http"]')
		.not('a[href^="' + $(location).attr('hostname')+'"]')
		.attr('target', '_blank')
		.attr('rel', 'nofollow');

	// Init shipping calculator
	if(Shopify.CountryProvinceSelector) {
		Shopify.Cart.ShippingCalculator.show({
			submitButton: theme.strings.shippingCalcSubmitButton,
			submitButtonDisabled: theme.strings.shippingCalcSubmitButtonDisabled,
			customerIsLoggedIn: theme.strings.shippingCalcCustomerIsLoggedIn,
			moneyFormat: theme.strings.shippingCalcMoneyFormat
		});
	}



	// Must check terms and conditions before going to checkout
	$(document).ready(function() {
		$('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
			if ($('#agree').is(':checked')) {
				$(this).submit();
			} else {
				alert("You must agree with the terms and conditions of sales to check out.");
				return false;
			}
		});
	});

});